export default __webpack_public_path__ + "static/media/ic_nuevos_lanzamientos_home_pro.e3fe70a7.svg";